module.exports = __webpack_public_path__ + "assets/img/xpdj.db57f22e.png";